import { PERMISSION } from '@/constants/permission.constant';

const departmentList = () => import('@/views/configuration/departments/List.vue');
const departmentAdd = () => import('@/views/configuration/departments/Add.vue');
const departmentEdit = () => import('@/views/configuration/departments/Edit.vue');

export const departmentRoute = [
  {
    path: '/configuration/departments',
    name: 'department',
    component: departmentList,
    meta: { requiresAuth: false, permissions: [PERMISSION.DEPARTMENT_READ] },
  },

  {
    path: '/configuration/departments/create',
    name: 'department-create',
    component: departmentAdd,
    meta: { requiresAuth: false, permissions: [PERMISSION.DEPARTMENT_CREATE] },
  },
  {
    path: '/configuration/departments/:id/edit',
    name: 'department-edit',
    component: departmentEdit,
    meta: { requiresAuth: false, permissions: [PERMISSION.DEPARTMENT_UPDATE] },
  },
];
